// src/services/roleService.ts
import { api } from './api';
import { RoleEntry, RolePermissions } from 'types/rbac';

export interface CreateRoleDto {
  name: string;
  hierarchyLevel: number;
  department?: string;
  permissions?: Partial<RolePermissions>;
}

export type UpdateRoleDto = Partial<CreateRoleDto> & { isActive?: boolean };

export const roleService = {
  getAll: async (): Promise<RoleEntry[]> => {
    const { data } = await api.get('/roles');
    return data;
  },

  create: async (dto: CreateRoleDto): Promise<RoleEntry> => {
    const { data } = await api.post('/roles', dto);
    return data;
  },

  update: async (id: string, dto: UpdateRoleDto): Promise<RoleEntry> => {
    const { data } = await api.patch(`/roles/${id}`, dto);
    return data;
  },

  // Soft — reversible, blocked nowhere. Use when a level should stop being
  // offered without breaking users/tasks that already reference it.
  deactivate: async (id: string): Promise<RoleEntry> => {
    const { data } = await api.patch(`/roles/${id}/deactivate`);
    return data;
  },

  // Hard — permanent. Backend rejects this if any user still has the role.
  remove: async (id: string): Promise<void> => {
    await api.delete(`/roles/${id}`);
  },
};
